import React, { useEffect, useState } from "react";
import axios from "axios";
import * as API from "../../Endpoints/Endpoints";

const GameHistory = () => {
  const [gameData, setGameData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [loggedInEmail, setLoggedInEmail] = useState(""); // Store logged-in user's email

  useEffect(() => {
    // Retrieve logged-in user's email from localStorage
    const storedEmail = localStorage.getItem("email");
    if (storedEmail) {
      setLoggedInEmail(storedEmail);
    }
  }, []);

  useEffect(() => {
    const fetchGameData = async () => {
      try {
        const response = await axios.get(API.GET_DECRYPTED_PLAY_API);
        const decryptedData = response.data.map((game) => ({
          ...game,
          scenario: game.scenario || "N/A",
          userInput: game.userInput || "N/A",
          response: game.response || "N/A",
          score: game.score || "N/A",
        }));

        setGameData(decryptedData);
      } catch (err) {
        setError(err.response?.data?.error || "Failed to fetch game data");
      } finally {
        setLoading(false);
      }
    };

    fetchGameData();
  }, []);

  // **Filter data for logged-in user**
  const filteredData = gameData.filter((game) => game.email === loggedInEmail);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold text-[#e64a32]">Your Game History</h1>

      {filteredData.length === 0 ? (
        <p className="text-gray-500">No history found for your account.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full border border-gray-300 rounded-lg shadow-lg table-auto">
            <thead>
              <tr className="bg-[#e64a32] text-white text-sm">
                {["ID", "Game Category", "Game Name", "Card Group", "Opened Cards", "Scenario", "User Input", "Response", "Time Elapsed", "Score", "KALKI Analysis"].map((heading, index) => (
                  <th key={index} className="border px-4 py-3 text-left whitespace-nowrap">
                    {heading}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredData.map((game, index) => (
                <tr key={index} className="even:bg-gray-100 hover:bg-gray-200 transition-all">
                  <td className="border px-4 py-2">{game.playid}</td>
                  <td className="border px-4 py-2">{game.selectedCategory}</td>
                  <td className="border px-4 py-2">{game.selectedGamename}</td>
                  <td className="border px-4 py-2">{game.selectedCardGroups}</td>
                  <td className="border px-4 py-2">{game.openedCards}</td>
                  <td className="border px-4 py-2">{game.scenario}</td>
                  <td className="border px-4 py-2">{game.userInput}</td>
                  <td className="border px-4 py-2 w-[250px]">{game.response}</td>
                  <td className="border px-4 py-2 w-[150px]">
                    {game.timeElapsed
                      ? typeof game.timeElapsed === "object"
                        ? `${game.timeElapsed.minutes || 0}m ${game.timeElapsed.seconds || 0}s`
                        : game.timeElapsed
                      : "N/A"}
                  </td>
                  <td className="border px-4 py-2 w-[150px]">{game.score}</td>
                  <td className="border px-4 py-2 w-[250px]">{game.analysis}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default GameHistory;
